import ActionBar from "./containers/ActionBar";
import SaasActionBar from "./saas/SaasActionBar";
import AvailabilityAlerts from "./AvailabilityAlerts";
import Description from "./Description";
import Features from "./Features";
import BundleOptions from "./BundleOptions";
import ExtraOptions from "./ExtraOptions";
import SaasExtraOptions from "./saas/SaasExtraOptions";
import React, { Component } from "react";
import {
  PRODUCT_IMAGE_BASE_URL,
  UNIFLOW_CPQ_PRODUCT_TYPE,
  IS_NZ
} from "../constants";
import style from "./ProductDetails.module.css";
import { connect } from "react-redux";
import {
  addCampaign,
  addQuoteItem,
  deleteQuoteItem,
  resetProduct,
  setAvailableOptions,
  setCustomAttributes,
  setCcBw,
  setCcColour,
  setDefaultCcBw,
  setDefaultCcColour,
  setDefaultScanCharge,
  setHasFallbackCcBw,
  setHasFallbackCcColour,
  setFlatMonthlyCharge,
  setDefaultFlatMonthlyCharge,
  setflatMonthlyChargeModifyable,
  setMsaCfa,
  setMsaDefaultCfa,
  setMsaDefaultMdsCost,
  setMsaDefaultTerm,
  setMsaInstalmentFrequency,
  setMsaMdsCost,
  setMsaMetroCcBw,
  setMsaMetroCcColour,
  setMsaPayableMethod,
  setMsaPriceFlag,
  setMsaRegionalCcBw,
  setMsaRegionalCcColour,
  setMsaTerm,
  setPickedOptionSelections,
  setQty,
  setScanCharge,
  setScanningMonthlyCharge,
  setDefaultScanningMonthlyCharge,
  setNzScanningMonthlyCharge,
  setDefaultNzScanningMonthlyCharge,
  setSubscriptionTargetChargeValue,
  setSubscriptionTerm,
  setSubscriptionUserNum,
  updateProductSelectionQty,
  updateProductSelectionTargetPrice,
  updateProductSelectionFinanceType,
  setMinimumMonthlyCharge,
  setDefaultMinimumMonthlyCharge,
  setMinimumMonthlyChargeModifiable,
  setTonerDeliveryCharge,
  setDefaultTonerDeliveryCharge,
  setPerA3Charge,
  setDefaultPerA3Charge,
  setSaasFinanceType,
  setSaasExistingTenant,
  setUserClickVolumeBw,
  setUserClickVolumeColour
} from "../redux/actions";
import {
  areChargesValid,
  areMsaOptionsValid,
  areSaasOptionsValid,
  hasCharges,
  isGovernmentOpportunity,
  hasSelectionsUnderWarranty
} from "../redux/selectors";

class ProductDetails extends Component {
  componentDidMount() {
    // Reset the active product in Redux
    this.props.resetProduct();

    // Quantity
    if (this.props.oldQuoteItem) {
      this.props.setQty(this.props.oldQuoteItem.qty);
      this.props.setUserClickVolumeBw(
        this.props.oldQuoteItem.userClickVolumeBw
      );
      this.props.setUserClickVolumeColour(
        this.props.oldQuoteItem.userClickVolumeColour
      );
    }

    this.props.setCustomAttributes(this.props.product.custom_attributes);

    // Available Options
    this.props.setAvailableOptions(
      this.props.product.options.map(option => {
        return {
          ...option,
          selections: option.selections.map(selection => {
            return {
              ...selection,
              financeType:
                this.isSaas && selection.is_saas
                  ? this.saasFinanceTypes[0]
                  : this.props.quoteFinance
            };
          })
        };
      })
    );

    // Picked Option Selections
    if (this.props.oldQuoteItem && this.props.oldQuoteItem.options) {
      this.props.setPickedOptionSelections({
        selectedOptions: this.props.oldQuoteItem.options,
        allOptions: this.props.product.options
      });

      // Need to update the quantity in availableOptions too
      this.props.oldQuoteItem.options.forEach(o =>
        o.selections.forEach(s =>
          this.props.updateProductSelectionQty({
            optionId: o.optionId,
            selectionId: s.selectionId,
            qty: s.qty,
            allOptions: this.props.product.options
          })
        )
      );

      //if SaaS bundle, we need to update targetPrice and financeType also
      if (this.props.oldQuoteItem.isSaas) {
        this.props.oldQuoteItem.options.forEach(o =>
          o.selections.forEach(s =>
            this.props.updateProductSelectionTargetPrice({
              optionId: o.optionId,
              selectionId: s.selectionId,
              targetPrice: s.targetPrice,
              allOptions: this.props.product.options
            })
          )
        );

        let saasFinanceType = null;
        this.props.oldQuoteItem.options.forEach(o =>
          o.selections
            .filter(sel => sel.isSaas)
            .forEach(s => {
              if (
                saasFinanceType === null &&
                this.saasFinanceTypes.includes(s.financeType)
              ) {
                saasFinanceType = s.financeType;
              }
            })
        );
        this.props.setSaasFinanceType(
          saasFinanceType || this.saasFinanceTypes[0]
        );
      }
    } else {
      this.props.setPickedOptionSelections({
        selectedOptions: this.getDefaultPickedOptionSelections(
          this.props.product.options
        ),
        allOptions: this.props.product.options
      });
    }

    // Campaigns
    const selectedCampaigns =
      this.props.oldQuoteItem && this.props.oldQuoteItem.ccCampaigns
        ? this.props.oldQuoteItem.ccCampaigns
        : [];
    this.getProductAttrValueByCode("cc_campaign")
      .split(",")
      .map(campaign => campaign.trim())
      .filter(campaign => campaign !== "")
      .map(campaign => ({
        name: campaign,
        isSelected: selectedCampaigns.includes(campaign)
      }))
      .forEach(campaign => this.props.addCampaign(campaign));

    // Uniflow subscription
    if (
      this.props.oldQuoteItem &&
      this.props.oldQuoteItem.subscriptionTargetChargeValue
    ) {
      this.props.setSubscriptionTargetChargeValue(
        Number(this.props.oldQuoteItem.subscriptionTargetChargeValue)
      );
    }
    if (
      this.props.oldQuoteItem &&
      this.props.oldQuoteItem.subscriptionUserNum
    ) {
      this.props.setSubscriptionUserNum(
        Number(this.props.oldQuoteItem.subscriptionUserNum)
      );
    }
    if (this.props.oldQuoteItem && this.props.oldQuoteItem.subscriptionTerm) {
      this.props.setSubscriptionTerm(
        Number(this.props.oldQuoteItem.subscriptionTerm)
      );
    }

    // Click / Scan Charges
    const {
      ccBw,
      ccColour,
      scanCharge,
      minimumMonthlyCharge,
      tonerDeliveryCharge,
      perA3Charge,
      nzScanningMonthlyCharge,
      flatMonthlyCharge,
      existingTenantValue
    } = this.props.oldQuoteItem || this.defaultCharges;

    this.props.setCcBw(ccBw);
    this.props.setHasFallbackCcBw(this.defaultCharges.hasFallbackBw);
    this.props.setDefaultCcBw(this.defaultCharges.ccBwValidation);
    this.props.setCcColour(ccColour);
    this.props.setHasFallbackCcColour(this.defaultCharges.hasFallbackColour);
    this.props.setDefaultCcColour(this.defaultCharges.ccColourValidation);
    this.props.setScanCharge(scanCharge);
    this.props.setDefaultScanCharge(this.defaultCharges.scanCharge);
    this.props.setScanningMonthlyCharge(this.scanningMonthlyCharge);
    this.props.setDefaultScanningMonthlyCharge(this.scanningMonthlyCharge);
    this.props.setNzScanningMonthlyCharge(nzScanningMonthlyCharge);
    this.props.setDefaultNzScanningMonthlyCharge(this.nzScanningMonthlyCharge);
    this.props.setFlatMonthlyCharge(flatMonthlyCharge);
    this.props.setDefaultFlatMonthlyCharge(this.flatMonthlyCharge);

    this.props.setMinimumMonthlyCharge(minimumMonthlyCharge);
    this.props.setDefaultMinimumMonthlyCharge(
      this.defaultCharges.minimumMonthlyCharge
    );
    this.props.setTonerDeliveryCharge(tonerDeliveryCharge);
    this.props.setDefaultTonerDeliveryCharge(this.tonerDeliveryCharges);
    this.props.setPerA3Charge(perA3Charge);
    this.props.setDefaultPerA3Charge(this.perA3Charges);
    this.props.setflatMonthlyChargeModifyable(this.flatMonthlyChargeModifyable);
    this.props.setMinimumMonthlyChargeModifiable(
      this.minimumMonthlyChargeModifiable
    );

    this.props.setSaasExistingTenant(existingTenantValue || "");

    // MSA Options
    if (this.props.isMsa) {
      const {
        msaTerm,
        msaCfa,
        msaMdsCost,
        msaPriceFlag,
        msaPayableMethod,
        msaInstalmentFrequency
      } = this.props.oldQuoteItem || this.defaultMsaOptions;

      this.props.setMsaDefaultTerm(this.defaultMsaOptions.msaTerm);
      this.props.setMsaTerm(msaTerm);

      this.props.setMsaDefaultCfa(this.defaultMsaOptions.msaCfa);
      this.props.setMsaCfa(msaCfa);

      this.props.setMsaDefaultMdsCost(this.defaultMsaOptions.msaMdsCost);
      this.props.setMsaMdsCost(msaMdsCost);

      this.props.setMsaPriceFlag(msaPriceFlag);
      this.props.setMsaPayableMethod(msaPayableMethod);
      this.props.setMsaInstalmentFrequency(msaInstalmentFrequency);

      this.props.setMsaMetroCcBw(this.defaultMsaOptions.msaMetroClickChargeBw);
      this.props.setMsaMetroCcColour(
        this.defaultMsaOptions.msaMetroClickChargeColour
      );
      this.props.setMsaRegionalCcBw(
        this.defaultMsaOptions.msaRegionalClickChargeBw
      );
      this.props.setMsaRegionalCcColour(
        this.defaultMsaOptions.msaRegionalClickChargeColour
      );
    }
  }

  componentWillUnmount() {
    this.props.resetProduct();
  }

  get mainUnit() {
    return this.props.product.type_id === "bundle"
      ? this.props.availableOptions
          .flatMap(option => option.selections)
          .filter(selection => selection.includes_main_unit)
          .map(selection => selection.product)[0]
      : null;
  }

  get defaultSelectedProducts() {
    return this.props.product.type_id === "bundle"
      ? this.props.availableOptions
          .flatMap(option => option.selections)
          .filter(selection => selection.is_default === "1")
          .map(selection => selection.product)
      : [];
  }

  get defaultMsaOptions() {
    const {
      terms, // "terms" is a misnomer, should be "term"
      cfa_per_device,
      mds_cost,
      price_flag_code,
      payable_method,
      instalment_frequency,
      click_charge_bw,
      click_charge_colour,
      click_charge_bw_regional,
      click_charge_colour_regional
    } = this.props.product.extension_attributes.msa;

    return {
      msaTerm: terms,
      msaCfa: cfa_per_device,
      msaMdsCost: mds_cost,

      msaPriceFlag: price_flag_code,
      msaPayableMethod: payable_method,
      msaInstalmentFrequency: instalment_frequency,

      msaMetroClickChargeBw: click_charge_bw,
      msaMetroClickChargeColour: click_charge_colour,
      msaRegionalClickChargeBw: click_charge_bw_regional,
      msaRegionalClickChargeColour: click_charge_colour_regional
    };
  }

  get defaultCharges() {
    let ccBw, ccColour;
    if (this.props.isMsa) {
      // The MSA-account-specific click charges
      ccBw = this.defaultMsaOptions.msaMetroClickChargeBw;
      ccColour = this.defaultMsaOptions.msaMetroClickChargeColour;
    } else if (this.props.isGovernmentOpportunity) {
      ccBw = this.getProductAttrValueByCode("cc_b_w_gov");
      ccColour = this.getProductAttrValueByCode("cc_colour_gov");
    } else {
      ccBw = this.getProductAttrValueByCode("cc_b_w");
      ccColour = this.getProductAttrValueByCode("cc_colour");
    }
    const scanCharge = this.getProductAttrValueByCode("scan_charge");
    const flatMonthlyCharge = this.flatMonthlyCharge;
    //set defaults for AU
    let tonerDeliveryCharge = null,
      perA3Charge = null,
      minimumMonthlyCharge = null,
      nzScanningMonthlyCharge = null;
    if (IS_NZ) {
      //overwrite values if NZ
      minimumMonthlyCharge = this.getProductAttrValueByCode(
        "nz_minimum_monthly_charge"
      );

      const tonerCharges = this.tonerDeliveryCharges;
      if (tonerCharges !== null) {
        tonerDeliveryCharge = tonerCharges[tonerCharges.length - 1];
      }

      const nzScan = this.nzScanningMonthlyCharge;
      if (nzScan !== null) {
        nzScanningMonthlyCharge = nzScan[nzScan.length - 1];
      }

      const A3Charges = this.getProductAttrValueByCode("nz_per_a3_charge");
      if (Array.isArray(A3Charges)) {
        const keyVal = Object.entries(A3Charges[0]);
        perA3Charge = keyVal[0][0];
      }
    }

    const ccBwArr = ccBw.split(",");
    const ccColArr = ccColour.split(",");
    const ccBwValidateVal = ccBwArr.length > 1 ? ccBwArr[1] : ccBw;
    const ccColourValidateVal = ccColArr.length > 1 ? ccColArr[1] : ccColour;
    const hasFallbackBw = ccBwArr.length > 1 ? true : false;
    const hasFallbackColour = ccColArr.length > 1 ? true : false;

    return {
      ccBw: this.sanitizeChargeValue(ccBwArr[0]),
      ccColour: this.sanitizeChargeValue(ccColArr[0]),
      ccBwValidation: this.sanitizeChargeValue(ccBwValidateVal),
      ccColourValidation: this.sanitizeChargeValue(ccColourValidateVal),
      hasFallbackBw: hasFallbackBw,
      hasFallbackColour: hasFallbackColour,
      scanCharge: this.sanitizeChargeValue(scanCharge),
      minimumMonthlyCharge:
        minimumMonthlyCharge !== null
          ? this.sanitizeChargeValue(minimumMonthlyCharge)
          : minimumMonthlyCharge,
      tonerDeliveryCharge: tonerDeliveryCharge,
      perA3Charge: perA3Charge,
      nzScanningMonthlyCharge: nzScanningMonthlyCharge,
      flatMonthlyCharge,
      existingTenantValue: ""
    };
  }

  get isBundleValid() {
    return (
      this.props.product.type_id !== "bundle" ||
      // The main unit must be enabled if exist
      (this.isMainUnitEnabled &&
        // The main unit must be under the current price list
        this.doesMainUnitHavePrice &&
        // All the default selected products must be enabled if exist
        this.areDefaultSelectionsEnabled &&
        // All the default selected products must be under the current price list if exist
        this.doDefaultSelectionsHavePrices)
    );
  }

  get canAddToCart() {
    if (this.isSaas) {
      return (
        // The Product must be enabled
        this.isEnabled &&
        // Are bundle options valid
        this.isBundleValid &&
        // The click charges are valid
        this.props.areChargesValid &&
        // Are MSA options valid
        this.props.areMsaOptionsValid &&
        //SaaS options are correct
        this.props.areSaasOptionsValid
      );
    } else {
      return (
        // The Product must be enabled
        this.isEnabled &&
        // Are bundle options valid
        this.isBundleValid &&
        // The click charges are valid
        this.props.areChargesValid &&
        // Are MSA options valid
        this.props.areMsaOptionsValid
      );
    }
  }

  get isEnabled() {
    return this.props.product.status === 1;
  }

  get isMainUnitEnabled() {
    return this.mainUnit ? this.mainUnit.status === "1" : true;
  }

  get doesMainUnitHavePrice() {
    return this.mainUnit ? this.mainUnit.price !== null : true;
  }

  get areDefaultSelectionsEnabled() {
    return this.defaultSelectedProducts.length
      ? this.defaultSelectedProducts.every(product => product.status === "1")
      : true;
  }

  get doDefaultSelectionsHavePrices() {
    return this.defaultSelectedProducts.length
      ? this.defaultSelectedProducts.every(product => product.price !== null)
      : true;
  }

  get price() {
    return this.props.product.type_id === "bundle"
      ? // Calculate the price for bundle products
        this.props.pickedOptionSelections
          .flatMap(o =>
            // Get the total price under a single option
            o.selections
              .filter(s => {
                return !s.isSaas;
              })
              .map(
                s =>
                  // Get a single selection price
                  s.price * s.qty
              )
          )
          .reduce((total, price) => total + price, 0)
      : // Return the price for simple products (assuming there are only bundle products and simple products)
        this.props.product.price;
  }

  get saasTargetPrice() {
    return this.props.pickedOptionSelections
      .flatMap(o =>
        // Get the total price under a single option
        o.selections
          .filter(s => {
            return s.isSaas;
          })
          .map(s => {
            // Get a single selection price
            return s.targetPrice * s.qty * this.props.subscriptionTerm;
          })
      )
      .reduce((total, price) => total + price, 0);
  }
  get saasMSP() {
    return this.props.pickedOptionSelections
      .flatMap(o =>
        // Get the total price under a single option
        o.selections
          .filter(s => {
            return s.isSaas;
          })
          .map(s => {
            // Get a single selection price
            return s.price * s.qty * this.props.subscriptionTerm;
          })
      )
      .reduce((total, price) => total + price, 0);
  }

  get image() {
    const path = this.getProductAttrValueByCode("image");

    return path ? `${PRODUCT_IMAGE_BASE_URL}${path}` : null;
  }

  get description() {
    return this.getProductAttrValueByCode(
      this.props.product.type_id === "bundle"
        ? "bundle_inclusion_description"
        : "short_description"
    );
  }

  get features() {
    return this.getProductAttrValueByCode("description");
  }

  get scanningMonthlyCharge() {
    return this.sanitizeChargeValue(
      this.getProductAttrValueByCode("scanning_monthly_charge")
    );
  }

  get nzScanningMonthlyCharge() {
    if (IS_NZ) {
      const scanningCharge = this.getProductAttrValueByCode(
        "nz_scanning_monthly_charge"
      );
      if (scanningCharge === undefined) return null;
      return scanningCharge !== ""
        ? scanningCharge
            .split(",")
            .filter(x => x.trim().length && !isNaN(x))
            .map(Number)
        : null;
    }
    return null;
  }
  get perA3Charges() {
    if (IS_NZ) {
      const perA3 = this.getProductAttrValueByCode("nz_per_a3_charge");
      if (perA3 === undefined) return null;
      return Array.isArray(perA3) ? perA3 : null;
    }
    return null;
  }
  get tonerDeliveryCharges() {
    if (IS_NZ) {
      const tonerDelivery = this.getProductAttrValueByCode(
        "nz_toner_delivery_charge"
      );
      if (tonerDelivery === undefined) return null;
      return tonerDelivery !== ""
        ? tonerDelivery
            .split(",")
            .filter(x => x.trim().length && !isNaN(x))
            .map(Number)
        : null;
    }
    return null;
  }
  get minimumMonthlyChargeModifiable() {
    const mod = this.getProductAttrValueByCode(
      "nz_minimum_monthly_charge_modifiable"
    );
    if (mod === undefined) return 0;
    return mod === "" ? 0 : mod;
  }
  get flatMonthlyChargeModifyable() {
    const mod = this.getProductAttrValueByCode(
      "flat_monthly_charge_modifiable"
    );
    if (mod === undefined) return 0;
    return mod === "" ? 0 : mod;
  }

  get flatMonthlyCharge() {
    return this.sanitizeChargeValue(
      this.getProductAttrValueByCode("flat_monthly_charge")
    );
  }

  get isUniflow() {
    return (
      this.getProductAttrValueByCode("cpq_product_type") ===
      UNIFLOW_CPQ_PRODUCT_TYPE
    );
  }

  get isSaas() {
    return this.getProductAttrValueByCode("is_bundle_saas") === "1";
  }
  get saasFinanceTypes() {
    return this.getProductAttrValueByCode("bundle_saas_finance_type").split(
      ","
    );
  }
  get saasCanChangeQuantity() {
    return (
      this.getProductAttrValueByCode("is_bundle_saas_allow_qty_change") === "1"
    );
  }
  get saasIsExistingTenant() {
    return this.getProductAttrValueByCode("bundle_saas_type") === "existing";
  }
  get saasExistingTenantLabel() {
    return this.getProductAttrValueByCode("bundle_saas_identifier");
  }
  get saasSubscriptionTermFrequency() {
    return this.getProductAttrValueByCode("bundle_saas_frequency");
  }

  getProductAttrValueByCode = attributeCode =>
    this.props.product.custom_attributes.reduce(
      (value, attr) =>
        attr.attribute_code === attributeCode ? attr.value : value,
      ""
    );

  sanitizeChargeValue = value =>
    !value ||
    String(value)
      .trim()
      .toUpperCase() === "N/A"
      ? 0
      : Number(value);

  /**
   * Get the default option selection out of the bundle options in product object.
   * It picks the default selections for all products or the first selection for required option.
   *
   * The fields in the passed-in options follow the snake_case.
   * E.g. option_id, selection_id, selection_qty
   *
   * @param options array Bundle options from the product object
   * @return array The default bundle selection object that can be used in quote
   */

  getDefaultPickedOptionSelections = options =>
    options
      ? options
          .map(o => {
            let defaultSelections = o.selections.filter(
              selection =>
                selection.is_default === "1" &&
                selection.product.status === "1" &&
                selection.product.price !== null
            );

            if (o.required === "1" && defaultSelections.length === 0) {
              defaultSelections = [o.selections[0]];
            }

            if (defaultSelections.length) {
              return {
                optionName: o.title,
                optionId: o.option_id,
                required: o.required,
                selections: defaultSelections.map(
                  ({
                    selection_id,
                    product_id,
                    selection_qty,
                    product,
                    exclude_from_margin_split,
                    includes_main_unit,
                    is_software,
                    is_hardware,
                    is_saas,
                    targetPrice
                  }) => ({
                    selectionId: selection_id,
                    productId: product_id,
                    sku: product.sku,
                    name: product.name,
                    price: Number(product.price),
                    targetPrice: Number(targetPrice),
                    financeType:
                      this.isSaas && is_saas
                        ? this.saasFinanceTypes[0]
                        : this.props.quoteFinance,
                    qty: selection_qty,
                    inventory_qty: product.inventory_qty,
                    excludeFromMarginSplit: exclude_from_margin_split,
                    includesMainUnit: includes_main_unit,
                    isSoftware: is_software,
                    isHardware: is_hardware,
                    isSaas: is_saas,
                    additionalLinkedPart: (product.additional_linked_part || "")
                      .trim()
                      .split(",")
                      .filter(Boolean)
                  })
                )
              };
            } else {
              return null;
            }
          })
          .filter(option => option !== null)
      : [];

  handleAddToQuote = () => {
    // Get the current product
    const { sku, name, id, type_id } = this.props.product;
    const { msaPriceFlag } = this.defaultMsaOptions;

    let extraOptions;
    if (this.isUniflow) {
      extraOptions = {
        subscriptionTargetChargeValue: this.props.subscriptionTargetChargeValue,
        subscriptionUserNum: this.props.subscriptionUserNum,
        subscriptionTerm: this.props.subscriptionTerm
      };
    } else if (this.props.hasSelectionsUnderWarranty) {
      extraOptions = {
        underWarranty: this.props.hasSelectionsUnderWarranty
      };
    } else if (this.props.hasCharges) {
      const perA3Obj =
        this.props.defaultPerA3Charge === null
          ? null
          : this.props.defaultPerA3Charge.find(item => {
              return item.hasOwnProperty(this.props.perA3Charge);
            });
      extraOptions = {
        ccBw: this.props.ccBw,
        ccColour: this.props.ccColour,
        defaultCcBw: this.props.defaultCcBw,
        defaultCcColour: this.props.defaultCcColour,
        userClickVolumeBw: this.props.userClickVolumeBw,
        userClickVolumeColour: this.props.userClickVolumeBw,
        scanCharge: this.props.scanCharge,
        scanningMonthlyCharge: this.props.scanningMonthlyCharge,
        flatMonthlyCharge: this.props.flatMonthlyCharge,

        //NZ
        perA3Charge: this.props.perA3Charge,
        perA3ChargeObject: perA3Obj,
        tonerDeliveryCharge: this.props.tonerDeliveryCharge,
        nzScanningMonthlyCharge: this.props.nzScanningMonthlyCharge,
        minimumMonthlyCharge: this.props.minimumMonthlyCharge
      };
    } else {
      extraOptions = {};
    }
    if (this.isSaas) {
      extraOptions.subscriptionTerm = this.props.subscriptionTerm;
      extraOptions.saasFinanceType = this.props.saasFinanceType;
      extraOptions.existingTenantLabel = this.saasIsExistingTenant
        ? this.saasExistingTenantLabel
        : null;
      extraOptions.existingTenantValue = this.saasIsExistingTenant
        ? this.props.saasExistingTenant
        : null;
    }

    //if any warranty product in the bundle has been selected, don't add click charges
    const msaOptions = this.props.isMsa
      ? Object.assign(
          {
            msaDefaultTerm: this.props.msaDefaultTerm,
            msaTerm: this.props.msaTerm,

            msaDefaultCfa: this.props.msaDefaultCfa,
            msaCfa: this.props.msaCfa,

            msaDefaultMdsCost: this.props.msaDefaultMdsCost,
            msaMdsCost: this.props.msaMdsCost,

            msaPriceFlag: this.props.hasSelectionsUnderWarranty
              ? "CPQ_N/A"
              : msaPriceFlag,
            msaPayableMethod: this.props.msaPayableMethod,
            msaInstalmentFrequency: this.props.msaInstalmentFrequency
          },
          this.props.hasSelectionsUnderWarranty
            ? {}
            : {
                msaMetroClickChargeBw: this.props.msaMetroClickChargeBw,
                msaMetroClickChargeColour: this.props.msaMetroClickChargeColour,
                msaRegionalClickChargeBw: this.props.msaRegionalClickChargeBw,
                msaRegionalClickChargeColour: this.props
                  .msaRegionalClickChargeColour
              }
        )
      : null;

    // Add to quote
    if (type_id === "bundle"){
      this.props.addQuoteItem(
        {
          //region Common Fields
          excludeFromMarginSplit:
            this.getProductAttrValueByCode("exclude_from_margin_split") === "1",
          image: this.image,
          isSoftware: this.getProductAttrValueByCode("ax_product_type") === "SW",
          isSaas: this.getProductAttrValueByCode("is_bundle_saas") === "1",
          isHardware:
            this.getProductAttrValueByCode("ax_product_type") !== "SW" &&
            this.getProductAttrValueByCode("is_bundle_saas") !== "1",
          name,
          price: this.price,
          saasTargetPrice: this.saasTargetPrice,
          saasMSP: this.saasMSP,
          productId: id,
          qty: this.props.qty,
          sku,
          type: type_id === "bundle" ? "bundle" : "simple",
          //endregion
  
          ccCampaigns: this.props.campaigns
            .filter(c => c.isSelected)
            .map(c => c.name),
  
          // Bundle Options
          options: type_id === "bundle" ? this.props.pickedOptionSelections : [],
  
          ...extraOptions,
          ...msaOptions
        },
        this.props.oldQuoteItem
      );
    }else{
      this.props.addQuoteItem(
        {
          //region Common Fields
          excludeFromMarginSplit:
            this.getProductAttrValueByCode("exclude_from_margin_split") === "1",
          image: this.image,
          isSoftware: this.getProductAttrValueByCode("ax_product_type") === "SW",
          isSaas: this.getProductAttrValueByCode("is_bundle_saas") === "1",
          isHardware:
            this.getProductAttrValueByCode("ax_product_type") !== "SW" &&
            this.getProductAttrValueByCode("is_bundle_saas") !== "1",
          name,
          price: this.price,
          productId: id,
          qty: this.props.qty,
          sku,
          type: type_id === "bundle" ? "bundle" : "simple",
          //endregion
        },
        this.props.oldQuoteItem
      );
    }
    

    this.props.history.push("/quote");
  };

  render() {
    return (
      <div className="product-view row product-row">
        <Description
          image={this.image}
          name={this.props.product.name}
          description={this.description}
          id={this.props.product.id}
          sku={this.props.product.sku}
        />
        {this.isSaas ? (
          <SaasActionBar
            name={this.props.product.name}
            saasTargetPrice={this.saasTargetPrice}
            saasotherprice={this.price}
            canChangeQuantity={this.saasCanChangeQuantity}
            handleAddToQuote={this.handleAddToQuote}
            isUpdate={!!this.props.oldQuoteItem}
            canAddToCart={this.canAddToCart}
          />
        ) : (
          <ActionBar
            name={this.props.product.name}
            price={this.price}
            canAddToCart={this.canAddToCart}
            handleAddToQuote={this.handleAddToQuote}
            isUpdate={!!this.props.oldQuoteItem}
          />
        )}

        <AvailabilityAlerts
          product={this.props.product}
          mainUnit={this.mainUnit}
          defaultSelectedProducts={this.defaultSelectedProducts}
          isEnabled={this.isEnabled}
          isMainUnitEnabled={this.isMainUnitEnabled}
          doesMainUnitHavePrice={this.doesMainUnitHavePrice}
          areDefaultSelectionsEnabled={this.areDefaultSelectionsEnabled}
          doDefaultSelectionsHavePrices={this.doDefaultSelectionsHavePrices}
        />

        <div
          className={
            this.isSaas ? style.saasCustomizations : style.customizations
          }
        >
          <BundleOptions isSaas={this.isSaas} />

          <div style={this.isSaas ? { width: "min-content" } : {}}>
            {this.isSaas ? (
              <SaasExtraOptions
                isUniflow={false}
                financeTypes={this.saasFinanceTypes}
                subscriptionTerm={this.props.subscriptionTerm}
                subscriptionTermFrequency={this.saasSubscriptionTermFrequency}
                onSubscriptionTermChanged={this.props.setSubscriptionTerm}
                financeType={this.props.saasFinanceType}
                onFinanceTypeChanged={this.props.setSaasFinanceType}
                isExisting={this.saasIsExistingTenant}
                ExistingTenantLabel={this.saasExistingTenantLabel}
                ExistingTenantValue={this.props.saasExistingTenant}
                onExistingTenantUpdated={this.props.setSaasExistingTenant}
              />
            ) : (
              <ExtraOptions isUniflow={this.isUniflow} />
            )}
          </div>
        </div>

        <Features features={this.features} />
      </div>
    );
  }
}

export default connect(
  state => {
    const {
      qty,
      availableOptions,
      pickedOptionSelections,
      subscriptionTargetChargeValue,
      subscriptionUserNum,
      subscriptionTerm,
      ccBw,
      ccColour,
      defaultCcBw,
      defaultCcColour,
      userClickVolumeBw,
      userClickVolumeColour,
      scanCharge,
      scanningMonthlyCharge,
      flatMonthlyCharge,
      campaigns,

      msaDefaultTerm,
      msaTerm,
      msaDefaultCfa,
      msaCfa,
      msaDefaultMdsCost,
      msaMdsCost,
      msaPriceFlag,
      msaPayableMethod,
      msaInstalmentFrequency,

      msaMetroClickChargeBw,
      msaMetroClickChargeColour,
      msaRegionalClickChargeBw,
      msaRegionalClickChargeColour,

      perA3Charge,
      defaultPerA3Charge,
      tonerDeliveryCharge,
      nzScanningMonthlyCharge,
      minimumMonthlyCharge,

      saasFinanceType,
      saasExistingTenant
    } = state.product;

    return {
      isMsa: state.quote.isMsa,
      hasCharges: hasCharges(state),
      isGovernmentOpportunity: isGovernmentOpportunity(state),
      hasSelectionsUnderWarranty: hasSelectionsUnderWarranty(state),
      qty,
      availableOptions,
      pickedOptionSelections,
      subscriptionTargetChargeValue,
      subscriptionUserNum,
      subscriptionTerm,
      ccBw,
      ccColour,
      defaultCcBw,
      defaultCcColour,
      userClickVolumeBw,
      userClickVolumeColour,
      scanCharge,
      scanningMonthlyCharge,
      flatMonthlyCharge,
      campaigns,
      areChargesValid: areChargesValid(state),
      areMsaOptionsValid: areMsaOptionsValid(state),
      areSaasOptionsValid: areSaasOptionsValid(state),

      msaDefaultTerm,
      msaTerm,
      msaDefaultCfa,
      msaCfa,
      msaDefaultMdsCost,
      msaMdsCost,
      msaPriceFlag,
      msaPayableMethod,
      msaInstalmentFrequency,

      msaMetroClickChargeBw,
      msaMetroClickChargeColour,
      msaRegionalClickChargeBw,
      msaRegionalClickChargeColour,

      perA3Charge,
      defaultPerA3Charge,
      tonerDeliveryCharge,
      nzScanningMonthlyCharge,
      minimumMonthlyCharge,

      saasFinanceType,
      saasExistingTenant,

      quoteFinance: state.quote.finance.financeType
    };
  },
  {
    updateProductSelectionQty,
    updateProductSelectionTargetPrice,
    updateProductSelectionFinanceType,
    resetProduct,
    addCampaign,
    setScanningMonthlyCharge,
    setDefaultScanningMonthlyCharge,
    setNzScanningMonthlyCharge,
    setDefaultNzScanningMonthlyCharge,
    setFlatMonthlyCharge,
    setDefaultFlatMonthlyCharge,
    setflatMonthlyChargeModifyable,
    setSubscriptionTargetChargeValue,
    setSubscriptionTerm,
    setSubscriptionUserNum,
    setCcBw,
    setCcColour,
    setScanCharge,
    setDefaultCcBw,
    setDefaultCcColour,
    setDefaultScanCharge,
    setHasFallbackCcBw,
    setHasFallbackCcColour,
    setQty,
    setAvailableOptions,
    setCustomAttributes,
    setPickedOptionSelections,
    addQuoteItem,
    deleteQuoteItem,
    setMsaTerm,
    setMsaDefaultTerm,
    setMsaCfa,
    setMsaDefaultCfa,
    setMsaMdsCost,
    setMsaDefaultMdsCost,
    setMsaPriceFlag,
    setMsaPayableMethod,
    setMsaInstalmentFrequency,
    setMsaMetroCcBw,
    setMsaMetroCcColour,
    setMsaRegionalCcBw,
    setMsaRegionalCcColour,
    setMinimumMonthlyCharge,
    setDefaultMinimumMonthlyCharge,
    setMinimumMonthlyChargeModifiable,
    setTonerDeliveryCharge,
    setDefaultTonerDeliveryCharge,
    setPerA3Charge,
    setDefaultPerA3Charge,
    setSaasFinanceType,
    setSaasExistingTenant,
    setUserClickVolumeBw,
    setUserClickVolumeColour
  }
)(ProductDetails);
